import { Field, TextInput, TextArea, Select } from "@/components/admin/AdminFormModal";
import ImageUpload from "@/components/admin/ImageUpload";
import { ICON_OPTIONS } from "./home-schemas";
import ListField from "./ListField";

export default function FieldRenderer({ field, value, onChange }) {
  const { type, name, label } = field;

  if (type === "list") {
    return (
      <ListField field={field} value={Array.isArray(value) ? value : []} onChange={onChange} />
    );
  }

  if (type === "lines") {
    const text = Array.isArray(value) ? value.join("\n") : value || "";
    return (
      <Field label={label} hint="One per line">
        <TextArea
          rows={5}
          value={text}
          onChange={(e) =>
            onChange(e.target.value.split("\n").map((s) => s.replace(/\r$/, "")))
          }
        />
      </Field>
    );
  }

  if (type === "image") {
    return (
      <Field label={label}>
        <ImageUpload value={value || ""} onChange={onChange} />
      </Field>
    );
  }

  if (type === "icon") {
    return (
      <Field label={label}>
        <Select value={value || ""} onChange={(e) => onChange(e.target.value)}>
          <option value="">— Select icon —</option>
          {ICON_OPTIONS.map((i) => (
            <option key={i} value={i}>{i}</option>
          ))}
        </Select>
      </Field>
    );
  }

  if (type === "textarea") {
    return (
      <Field label={label}>
        <TextArea rows={3} value={value || ""} onChange={(e) => onChange(e.target.value)} />
      </Field>
    );
  }

  return (
    <Field label={label}>
      <TextInput
        type="text"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        name={name}
      />
    </Field>
  );
}
